import {
  batchCreateBasicField,
  batchDeleteElementAndSubs,
  createFieldValue,
  getNestedOrFloatingElementById,
  INDEXED_INCORRECTLY,
} from '@fs/zion-sls'
import { FullTextApp } from '../../../../../shared/services/config'

function handleExistingField(defaultValues, fact, existingField, attr) {
  const defaultValue = defaultValues?.additionalFacts.find((defaultVal) => defaultVal.id === fact.id)
  if (fact.value !== defaultValue?.value) {
    const fieldValue = createFieldValue(fact.value, { ...attr, reasonId: INDEXED_INCORRECTLY })
    return [
      {
        type: 'ADD_FV',
        value: {
          id: fact.id,
          partitionKey: existingField.partitionKey,
          fieldValue,
        },
      },
    ]
  }
  return []
}

function handleNewField(person, fact, attr) {
  const fieldValue = createFieldValue(fact.value, { ...attr, reasonId: INDEXED_INCORRECTLY })

  return batchCreateBasicField({
    partitionKey: person.partitionKey,
    superId: person.id,
    id: fact.id,
    fieldType: fact.key,
    superElementType: 'PERSON',
    fieldValue,
  })
}

function getUnlinkDispatch(fact, person) {
  return {
    type: 'REM_SUB',
    value: {
      superPartitionKey: person.partitionKey,
      subPartitionKey: fact.partitionKey,
      superId: person.id,
      subId: fact.id,
      elementType: 'PERSON',
    },
  }
}

/**
 * Generates dispatch actions for editing, adding, and removing additional facts.
 * @param {Array} additionalFacts - the values of the form associated with additional facts
 * @param {Object} defaultValues - values the form was initialized with
 * @param {Object} person - the SLS person object being edited
 * @param {Array} images - the SLS images array
 * @param {Array} confirmedUnlinkList - fact and person pairs to unlink (REM_SUB from person) This is a special feature for unlinking from other persons than the one being edited
 * @returns {Array} Array of dispatch actions to be processed
 */
export default function getAdditionalFactDispatches({
  additionalFacts,
  defaultValues,
  person,
  images,
  confirmedUnlinkList,
}) {
  let dispatches = []
  const attr = { comment: '', reasonId: '', app: FullTextApp } // Eric said to use an empty reason id when creating new fields

  additionalFacts.forEach((fact) => {
    const existingField = getNestedOrFloatingElementById(images, fact.id)
    if (existingField) {
      dispatches = dispatches.concat(handleExistingField(defaultValues, fact, existingField, attr))
    } else {
      dispatches = dispatches.concat(handleNewField(person, fact, attr))
    }
  })

  defaultValues.additionalFacts.forEach((fact) => {
    if (!additionalFacts.find((af) => af.id === fact.id)) {
      const existingField = getNestedOrFloatingElementById(images, fact.id)
      if (existingField) {
        if (existingField.superElements?.length > 1) {
          dispatches.push(getUnlinkDispatch(existingField, person))
        } else {
          // Field was deleted in the form, so delete it in SLS
          dispatches = dispatches.concat(batchDeleteElementAndSubs({ element: existingField }))
        }
      }
    }
  })
  confirmedUnlinkList?.forEach((confirmedUnlink) => {
    dispatches.push(
      getUnlinkDispatch(getNestedOrFloatingElementById(images, confirmedUnlink.fact.id), confirmedUnlink.person)
    )
  })

  return dispatches
}
